import { faqCusto, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const clinicas: ProfessionPageConfig = {
  path: '/ia-para-clinicas-e-consultorios/',
  key: 'clinicas',
  title: 'IA para recepção de clínica e consultório | Oficina IA',
  description:
    'Três tarefas da recepção que a IA adianta numa pasta: confirmações do dia com mensagem pronta, cadastro sem repetidos e relatório de faltas.',
  imageAlt: 'Oficina IA: IA para clínicas e consultórios',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para clínicas e consultórios e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para clínicas e consultórios',
  intro:
    'Confirmar consulta uma a uma, cadastro repetido, falta sem aviso. Aqui estão três tarefas da recepção que a IA pode ajudar a adiantar, sem programar. A conversa com o paciente continua sua.',
  rogerio: { pose: 'pedindo-esclarecimento', text: 'Confirmar um por um cansa. Confirmar em lista, não.' },
  tasks: [
    {
      title: 'Confirmações do dia',
      tone: 'sky',
      brings: 'a agenda de amanhã, exportada ou fotografada.',
      helps: 'monta a lista com a mensagem de confirmação pronta para cada paciente.',
      continues: 'copia e manda, um por um ou em bloco.',
    },
    {
      title: 'Cadastro sem repetidos',
      tone: 'peach',
      brings: 'as fichas em papel, fotografadas.',
      helps: 'digita tudo numa planilha e aponta quem aparece duas vezes.',
      continues: 'confere a aba de dúvidas e importa no sistema.',
    },
    {
      title: 'Faltas e remarcações da semana',
      tone: 'sage',
      brings: 'a agenda da semana com o que aconteceu.',
      helps: 'monta o relatório: quem faltou, quem remarcou, quem precisa de retorno.',
      continues: 'entrega para o profissional e liga para quem precisa.',
    },
  ],
  steps: {
    do: 'A IA monta a lista, a planilha ou o relatório dentro da sua pasta.',
    check: 'Confira nomes e horários antes de mandar qualquer mensagem. A IA pode se enganar; o paciente é seu.',
    resume: 'No dia seguinte, troque a agenda e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai responder os pacientes?',
      answer: 'Nas tarefas desta página, quem fala com o paciente é você. A IA prepara a lista e a mensagem; o envio e a conversa continuam seus.',
    },
    {
      question: 'E os dados dos pacientes?',
      answer: 'Dados de saúde pedem cuidado. Antes de colocar fichas na pasta, combine com quem responde pela clínica o que pode entrar e leia os termos da ferramenta que escolher.',
    },
    faqCusto,
  ],
  closing: {
    title: 'A primeira agenda confirmada, com alguém do lado.',
    text: 'Traga a agenda de amanhã, o cadastro repetido ou as faltas da semana.',
    rogerio: 'Eu cuido do novelo. Você cuida da recepção.',
  },
}
